import React from 'react';
import List from '@material-ui/core/List';
import { makeStyles } from '@material-ui/core/styles';

import _ from 'lodash';

import IndexItem from './components/IndexItem';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Accordion } from '@material-ui/core';
import { AccordionSummary } from '@material-ui/core';
import { AccordionDetails } from '@material-ui/core';

import Avatar from '@material-ui/core/Avatar';

import styles from './styles';
const useStyles = makeStyles(styles);

function IndexedServices(props) {
    const classes = useStyles();
    const { services, searchText, onSelect, selectedLetter } = props;

    const ordenedServices = _.orderBy(services, ['letter'], ['asc']);

    const hasSeachText = (values) => {
        return values.some((item) => {
            return item.nmServico.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
        });
    };

    return (
        <div className={classes.container}>
            <List disablePadding subheader={<li />}>
                {ordenedServices.map((letterSection) => {
                    if (
                        (selectedLetter !== '' && selectedLetter !== letterSection.letter) ||
                        (selectedLetter === '' && letterSection.values.length === 0) ||
                        (selectedLetter === '' && searchText && !hasSeachText(letterSection.values))
                    ) {
                        return null;
                    }
                    return (
                        <li key={letterSection.letter} className={classes.letter}>
                            <ul className={classes.values}>
                                <Accordion defaultExpanded className={classes.panel}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        className={classes.letterSection}
                                        classes={{ expanded: classes.summaryExpanded }}>
                                        <Avatar
                                            className={
                                                selectedLetter !== letterSection.letter
                                                    ? classes.inactiveCircle
                                                    : classes.activeCircle
                                            }>
                                            {letterSection.letter}
                                        </Avatar>
                                    </AccordionSummary>
                                    <AccordionDetails className={classes.details}>
                                        {letterSection.values.map((service) => {
                                            if (
                                                searchText &&
                                                service.nmServico.toLowerCase().indexOf(searchText.toLowerCase()) === -1
                                            ) {
                                                return null;
                                            }
                                            return (
                                                <IndexItem
                                                    key={service.cdServico}
                                                    service={service}
                                                    onSelect={onSelect}
                                                />
                                            );
                                        })}
                                    </AccordionDetails>
                                </Accordion>
                            </ul>
                        </li>
                    );
                })}
            </List>
        </div>
    );
}

export default IndexedServices;
